import React, { Component } from "react"
import Svg from "../_svgs/svg"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"
import { handleClickTracking } from "../../helpers/tracking"

export default class ServiceContentContainer extends Component {
  render() {
    if (this.props.contentArea && this.props.contentArea.length > 0) {
      const topPadding = SelectionFactoryHelper.getFromSelectionFactory(this.props.topPadding)
      return (
        <div className={`service-content ${topPadding ? topPadding : ""}`}>
          <div className="w--wider">
            <div className="backgroundbox">
              <div className="grid">
                {this.props.contentArea.map((item, index) => {
                  const { linkTarget, linkText, linkTracking, linkUrl } = item.link
                  const target = SelectionFactoryHelper.getFromSelectionFactory(linkTarget)
                  const icon = SelectionFactoryHelper.getFromSelectionFactory(item.icon)
                  return (
                    <a
                      key={index}
                      href={linkUrl}
                      target={target}
                      onClick={() => handleClickTracking(linkTracking)}
                      className="grid-item col--12 col-sm--4"
                    >
                      <div className="gicontent">
                        {item.iconUpload ? (
                          <div className="icon">
                            <img src={item.iconUpload} alt="icon" />
                          </div>
                        ) : icon ? (
                          <Svg iconName={icon} fillColor={"#FFF"} renderContainer={false} />
                        ) : (
                          ""
                        )}
                        <div className="maintext">{linkText}</div>
                      </div>
                    </a>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      )
    }
    return ""
  }
}
